// Shared data-model enums for the Company Manager "Email Domains" feature (DEV-4575).
// Backend (DEV-4573) is not built yet — these are the contract both the stubbed API
// responses (app/services/api/emailSendingDomains.stub.js) and the UI are written
// against, so swapping the stub for the real endpoint later requires no enum changes.

// NOTE: Values match the Skynet.Accounts EmailSendingDomainKind C# enum member names exactly
// (Primary/Subdomain/Managed) — `kind` is sent verbatim on create, and while the backend's
// StrictStringEnumConverter deserializes case-insensitively, matching the member names avoids
// relying on that and keeps all three tiers consistent. Inbound reads are normalized by matchEnum.
export const EmailDomainKind = {
  PRIMARY: 'Primary',
  SUBDOMAIN: 'Subdomain',
  MANAGED: 'Managed',
};

export const EmailDomainStatus = {
  VERIFIED: 'VERIFIED',
  PENDING: 'PENDING',
};

export const DnsRecordType = {
  CNAME: 'CNAME',
  TXT: 'TXT',
  MX: 'MX',
};

export const DnsRecordStatus = {
  VERIFIED: 'VERIFIED',
  PROPAGATING: 'PROPAGATING',
  NOT_FOUND: 'NOT_FOUND',
  DETECTED: 'DETECTED',
};
